/**
 * This file is autogenerated by py_nats_stub_gen
 * Do not edit this file manually!!
 * => Instead, re-generate it. Check the py-nats-stub-gen repo for more info
 **/
import type { ApiCaller } from "../wire/ApiCaller";
import type {
  AddShapeRequest,
  AddShapeResponse,
  AddStickyToIterationRequest,
  AddStickyToIterationResponse,
  CreateStickyOnRiskBoardRequest,
  CreateStickyOnRiskBoardResponse,
  CreateStickyRequest,
  CreateStickyResponse,
  EditShapeRequest,
  GetBoardStateRequest,
  GetBoardStateResponse,
  GetDiffRequest,
  GetDiffResponse,
  GetEventLogRequest,
  GetEventLogResponse,
  GetIterationsResponse,
  GetObjectivesRequest,
  GetObjectivesResponse,
  GetSignalsResponse,
  GetStickiesRequest,
  GetStickiesResponse,
  GetStickyScaleResponse,
  MirrorStickyRequest,
  MirrorStickyResponse,
  NoData,
  RemoveShapeRequest,
  UpdateStickyRequest,
  UpdateVelocityRequest,
} from "./models";
import {
  addShapeResponseSchema,
  addStickyToIterationResponseSchema,
  createStickyOnRiskBoardResponseSchema,
  createStickyResponseSchema,
  getBoardStateResponseSchema,
  getDiffResponseSchema,
  getEventLogResponseSchema,
  getIterationsResponseSchema,
  getObjectivesResponseSchema,
  getSignalsResponseSchema,
  getStickiesResponseSchema,
  getStickyScaleResponseSchema,
  mirrorStickyResponseSchema,
  noDataSchema,
} from "./schemas";

export class BoardApiClient {
  constructor(private caller: ApiCaller) {}

  async createSticky(
    payload: CreateStickyRequest,
    boardId: string,
    timeout?: number,
  ): Promise<CreateStickyResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.board.v1.boards.${boardId}.stickies.create",
        variables: { boardId: String(boardId) },
      },
      "createSticky",
      payload,
      { schema: createStickyResponseSchema, timeout },
    );
  }

  async getStickies(
    payload: GetStickiesRequest,
    boardId: string,
    timeout?: number,
  ): Promise<GetStickiesResponse> {
    return await this.caller.request(
      {
        template: "pip.${companyId}.${userId}.${role}.rpc.board.v1.boards.${boardId}.stickies.get",
        variables: { boardId: String(boardId) },
      },
      "getStickies",
      payload,
      { schema: getStickiesResponseSchema, timeout },
    );
  }

  async createRiskBoardSticky(
    payload: CreateStickyOnRiskBoardRequest,
    boardId: string,
    timeout?: number,
  ): Promise<CreateStickyOnRiskBoardResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.board.v1.boards.${boardId}.risk_board_stickies.create",
        variables: { boardId: String(boardId) },
      },
      "createRiskBoardSticky",
      payload,
      { schema: createStickyOnRiskBoardResponseSchema, timeout },
    );
  }

  async updateSticky(
    payload: UpdateStickyRequest,
    boardId: string,
    stickyId: string,
    timeout?: number,
  ): Promise<NoData> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.board.v1.boards.${boardId}.stickies.${stickyId}.update",
        variables: { boardId: String(boardId), stickyId: String(stickyId) },
      },
      "updateSticky",
      payload,
      { schema: noDataSchema, timeout },
    );
  }

  async addStickyToIteration(
    payload: AddStickyToIterationRequest,
    boardId: string,
    iterationId: number,
    timeout?: number,
  ): Promise<AddStickyToIterationResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.board.v1.boards.${boardId}.iterations.${iterationId}.stickies.create",
        variables: { boardId: String(boardId), iterationId: String(iterationId) },
      },
      "addStickyToIteration",
      payload,
      { schema: addStickyToIterationResponseSchema, timeout },
    );
  }

  async updateVelocity(
    payload: UpdateVelocityRequest,
    boardId: string,
    timeout?: number,
  ): Promise<NoData> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.board.v1.boards.${boardId}.velocity.update",
        variables: { boardId: String(boardId) },
      },
      "updateVelocity",
      payload,
      { schema: noDataSchema, timeout },
    );
  }

  async mirrorSticky(
    payload: MirrorStickyRequest,
    boardId: string,
    stickyId: string,
    timeout?: number,
  ): Promise<MirrorStickyResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.board.v1.boards.${boardId}.stickies.${stickyId}.mirror",
        variables: { boardId: String(boardId), stickyId: String(stickyId) },
      },
      "mirrorSticky",
      payload,
      { schema: mirrorStickyResponseSchema, timeout },
    );
  }

  async getStickyScale(boardId: string, timeout?: number): Promise<GetStickyScaleResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.board.v1.boards.${boardId}.sticky_scale.get",
        variables: { boardId: String(boardId) },
      },
      "getStickyScale",
      {},
      { schema: getStickyScaleResponseSchema, timeout },
    );
  }

  async getIterations(boardId: string, timeout?: number): Promise<GetIterationsResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.board.v1.boards.${boardId}.iterations.get",
        variables: { boardId: String(boardId) },
      },
      "getIterations",
      {},
      { schema: getIterationsResponseSchema, timeout },
    );
  }

  async getSignals(boardId: string, timeout?: number): Promise<GetSignalsResponse> {
    return await this.caller.request(
      {
        template: "pip.${companyId}.${userId}.${role}.rpc.board.v1.boards.${boardId}.signals.get",
        variables: { boardId: String(boardId) },
      },
      "getSignals",
      {},
      { schema: getSignalsResponseSchema, timeout },
    );
  }

  async getObjectives(
    payload: GetObjectivesRequest,
    boardId: string,
    timeout?: number,
  ): Promise<GetObjectivesResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.board.v1.boards.${boardId}.objectives.get",
        variables: { boardId: String(boardId) },
      },
      "getObjectives",
      payload,
      { schema: getObjectivesResponseSchema, timeout },
    );
  }

  async addShape(
    payload: AddShapeRequest,
    boardId: string,
    timeout?: number,
  ): Promise<AddShapeResponse> {
    return await this.caller.request(
      {
        template: "pip.${companyId}.${userId}.${role}.rpc.board.v1.boards.${boardId}.shapes.add",
        variables: { boardId: String(boardId) },
      },
      "addShape",
      payload,
      { schema: addShapeResponseSchema, timeout },
    );
  }

  async editShape(payload: EditShapeRequest, boardId: string, timeout?: number): Promise<NoData> {
    return await this.caller.request(
      {
        template: "pip.${companyId}.${userId}.${role}.rpc.board.v1.boards.${boardId}.shapes.update",
        variables: { boardId: String(boardId) },
      },
      "editShape",
      payload,
      { schema: noDataSchema, timeout },
    );
  }

  async removeShape(
    payload: RemoveShapeRequest,
    boardId: string,
    timeout?: number,
  ): Promise<NoData> {
    return await this.caller.request(
      {
        template: "pip.${companyId}.${userId}.${role}.rpc.board.v1.boards.${boardId}.shapes.delete",
        variables: { boardId: String(boardId) },
      },
      "removeShape",
      payload,
      { schema: noDataSchema, timeout },
    );
  }

  async getDiff(
    payload: GetDiffRequest,
    boardId: string,
    timeout?: number,
  ): Promise<GetDiffResponse> {
    return await this.caller.request(
      {
        template: "pip.${companyId}.${userId}.${role}.rpc.board.v1.boards.${boardId}.diff.get",
        variables: { boardId: String(boardId) },
      },
      "getDiff",
      payload,
      { schema: getDiffResponseSchema, timeout },
    );
  }

  async getEventLog(
    payload: GetEventLogRequest,
    boardId: string,
    timeout?: number,
  ): Promise<GetEventLogResponse> {
    return await this.caller.request(
      {
        template: "pip.${companyId}.${userId}.${role}.rpc.board.v1.boards.${boardId}.event_log.get",
        variables: { boardId: String(boardId) },
      },
      "getEventLog",
      payload,
      { schema: getEventLogResponseSchema, timeout },
    );
  }

  async getState(
    payload: GetBoardStateRequest,
    boardId: string,
    timeout?: number,
  ): Promise<GetBoardStateResponse> {
    return await this.caller.request(
      {
        template: "pip.${companyId}.${userId}.${role}.rpc.board.v1.boards.${boardId}.state.get",
        variables: { boardId: String(boardId) },
      },
      "getState",
      payload,
      { schema: getBoardStateResponseSchema, timeout },
    );
  }
}
